<div class="row mb-3">
    <div class="col-3">
        <img class="image-icon-sm" src="content/images/measurements.svg" />
        <span class="d-inline-flex p-2 h5 fw-bold">{{ 'study-editor.crosses-and-selection.title' | translate}}</span>
    </div>
</div>
<div class="row">
    <div class="col-12">
        <div class="d-flex justify-content-between align-items-center">
            <div>
                <div class="col">
					<span jhiTranslate="global.total.entries" [translateValues]="{param: numberOfEntries}"></span>
                </div>

            </div>
        </div>
    </div>
</div>
<div class="container-fluid mt-3 ps-0 pe-0">
    <!-- Germplasm Study Source Table Section -->
    <div>
        <div class="row">
            <div class="col-10">
                <div class="col d-flex align-items-center">
                    <label class="col-auto" jhiTranslate="global.records.per.page">Records per page: </label>
                    <div class="col-1 ms-2">
                        <select class="form-select form-select-sm"
                                [(ngModel)]="pageSize"
                                (change)="onPageSizeChange($event)">
                            <option value="50">50</option>
                            <option value="75">75</option>
                            <option value="100">100</option>
                        </select>
                    </div>
                    <div class="col-5 d-flex align-items-center justify-content-start">
                            <jhi-selection-count [showSelectAll]="true"
                                                 [isSelectAll]="isSelectAll"
                                                 [totalItemsSize]="numberOfFilteredEntries || numberOfEntries"
                                                 [selectedItemsSize]="selectedItems.size"
                                                 (deselectAction)="clearSelected()"
                                                 (selectAllAction)="selectAll($event)"></jhi-selection-count>
                        <button class="btn btn-sm btn-outline-info ms-2" (click)="clearFilters()"><i class="fa fa-filter-circle-xmark me-1"></i>
							<span jhiTranslate="study-editor.clear.filter">Clear Filter</span></button>
                    </div>
                </div>
            </div>
            <div class="col-2 d-flex justify-content-end align-items-center">
                @if (hasCreateLotsPermission) {
                    <div ngbDropdown container="body" class="d-inline-block ps-2" placement="bottom-right">
                        <button class="btn btn-sm btn-info" id="columnsDropdown" ngbDropdownToggle>
                            <span>{{ 'study-editor.crosses-and-selection.actions' | translate}}</span>
                        </button>
                        <div ngbDropdownMenu aria-labelledby="columnsDropdown">
                            <button ngbDropdownItem type="button" class="dropdown-item" (click)="openLotCreationModal()">
                                <span class="ms-1">{{ 'study-editor.crosses-and-selection.actions.create-lots' | translate}}</span>
                            </button>
                        </div>
                    </div>
                }
                <div class="ms-1">
                    <jhi-column-selector [displayedColumns]="displayedColumns"
                                         [columnDataService]="columnDataService"
                                         [showGroupToggle]="false"
                                         (reset)="onColumnSelectorReset()"
                                         ></jhi-column-selector>
                </div>
            </div>
        </div>
        <!-- Data Table -->
        <div class="table-responsive mt-3">
            <div class="custom-scroll-style adjustable-height">
                <table id="germplasm-checks-table"
                       class="table table-striped table-bordered table-curved table-editable">
                    <thead class="sticky-header">
                    <tr>
                        @for (column of displayedColumns; track trackColumnsById(column)) {
                            @if (column.selected && column.visible) {
                                <th class="default">
                                    @if (getStaticColumnLabelKey(column.termId)) {
                                        {{ getStaticColumnLabelKey(column.termId) | translate }}
                                    } @else {
                                        {{ column.displayName }}
                                    }

                                    @if (column.termId === STATIC_COLUMN_CHECKBOX) {
                                        <input type="checkbox" class="form-check-input m-1"
                                               [ngbTooltip]="'global.select.current.page' | translate"
                                               [checked]="isPageSelected()"
                                               (click)="onSelectPage()">
                                    }

                                    @if (column.id !== STATIC_COLUMN_CHECKBOX && column.id !== ROW_NUMBER && column.id !== STATIC_COLUMN_CROSS) {
                                        <span class="cursor-pointer ms-1"
                                              #p="ngbPopover"
                                              (click)="showColumnFilterPopover(column, p)"
                                              [autoClose]="'outside'"
                                              [ngbPopover]="columnFilterTemplate"
                                              container="body"
                                              [placement]="['bottom', 'right', 'auto']"
                                              triggers="manual">
                                    <i class="fa fa-filter ps-1" [ngClass]="{'filtering-by': column.isFiltered}"></i>
                                            @if (column.sortingAsc !== undefined && column.sortingAsc !== null) {
                                                <i class="ps-1 fa fa-icon-active"
                                                   [ngClass]="{'fa-sort-asc': column.sortingAsc, 'fa-sort-desc': !column.sortingAsc}">
                                        </i>
                                            }
                                </span>
                                    }
                                </th>
                            }
                        }
                    </tr>
                    </thead>
                    <tbody>
                        @if (entries.length !== 0) {
                            @for (entry of entries; track trackRowsById(entry); let row = $index) {
                                <tr
                                        (click)="toggleSelect($event, row, entry); $event.stopPropagation()"
                                        [class.selected]="isSelected(entry.germplasmStudySourceId)"
                                        (mousedown)="preventDefaultOnShiftKey($event)">
                                    @for (column of displayedColumns; track trackColumnsById(column); let col = $index) {
                                        <td *ngIf="column.selected && column.visible">
                                            @switch (true) {
                                                @case (STATIC_COLUMN_CHECKBOX === column.id) {
                                                    <input type="checkbox" class="form-check-input m-1"
                                                           [checked]="isSelected(entry.germplasmStudySourceId)"
                                                           (change)="toggleSelect($event, row, entry, true)"
                                                           (click)="$event.stopPropagation()"/>
                                                }
                                                @case (ROW_NUMBER === column.id) {
                                                    {{ (currentPage - 1) * pageSize + row + 1 }}
                                                }
                                                @case (STATIC_COLUMN_GID === column.id) {
                                                    @if (entry.gid && hasViewGermplasmDetailsPermission) {
                                                        <a  href="javascript:void(0)" class="link" (click)="germplasmDetailsPopupService.open(entry.gid)"><truncate-span [textInput]="entry.gid"></truncate-span></a>
                                                    } @else if (entry.gid) {
                                                        <truncate-span [textInput]="entry.gid"></truncate-span>
                                                    } @else {
                                                        <span>-</span>
                                                    }
                                                }
                                                @case (STATIC_COLUMN_GROUPGID === column.id) {
                                                    @if (entry.groupId) {
                                                        {{ entry.groupId }}
                                                    } @else {
                                                        <span>-</span>
                                                    }
                                                }
                                                @case (STATIC_COLUMN_DESIGNATION === column.id) {
                                                    @if (entry.designation && hasViewGermplasmDetailsPermission) {
                                                        <a  href="javascript:void(0)"  class="link" (click)="germplasmDetailsPopupService.open(entry.gid)"><truncate-span [textInput]="entry.designation" [maxLength]="MAX_NAME_DISPLAY_SIZE"></truncate-span></a>
                                                    } @else if (entry.designation) {
                                                        <truncate-span [textInput]="entry.designation" [maxLength]="MAX_NAME_DISPLAY_SIZE"></truncate-span>
                                                    } @else {
                                                        <span>-</span>
                                                    }
                                                }
                                                @case (STATIC_COLUMN_CROSS === column.id) {
                                                    @if (entry.cross) {
                                                        <truncate-span [textInput]="entry.cross" [maxLength]="MAX_NAME_DISPLAY_SIZE"></truncate-span>
                                                    } @else {
                                                        <span>-</span>
                                                    }
                                                }
                                                @case (STATIC_COLUMN_ACTIVE_LOT === column.id) {
                                                    @if (entry.numberOfLots) {
                                                        <a  href="javascript:void(0)" class="link" (click)="inventoryDetailsPopupService.open(entry.gid)">{{ entry.numberOfLots }}</a>
                                                    } @else {
                                                        <span>-</span>
                                                    }
                                                }
                                                @case (STATIC_COLUMN_BREEDING_METHOD_ABBR === column.id) {
                                                    @if (entry.breedingMethodAbbreviation) {
                                                        <span>{{ entry.breedingMethodAbbreviation }}</span>
                                                    } @else {
                                                        <span>-</span>
                                                    }
                                                }
                                                @case (STATIC_COLUMN_BREEDING_METHOD_NAME === column.id) {
                                                    @if (entry.breedingMethodName) {
                                                        <truncate-span [textInput]="entry.breedingMethodName"></truncate-span>
                                                    } @else {
                                                        <span>-</span>
                                                    }
                                                }
                                                @case (STATIC_COLUMN_BREEDING_METHOD_TYPE === column.id) {
                                                    @if (entry.breedingMethodType) {
                                                        {{ entry.breedingMethodType }}
                                                    } @else {
                                                        <span>-</span>
                                                    }
                                                }
                                                @case (STATIC_COLUMN_BREEDING_LOCATION_NAME === column.id) {
                                                    @if (entry.breedingLocationName) {
                                                        <truncate-span [textInput]="entry.breedingLocationName"></truncate-span>
                                                    } @else {
                                                        <span>-</span>
                                                    }
                                                }
                                                @case (TRIAL_INSTANCE === column.id) {
                                                    @if (entry.trialInstance) {
                                                        {{ entry.trialInstance }}
                                                    } @else {
                                                        <span>-</span>
                                                    }
                                                }
                                                @case (PLOT_NUMBER === column.id) {
                                                    @if (entry.plotNumber) {
                                                        {{ entry.plotNumber }}
                                                    } @else {
                                                        <span>-</span>
                                                    }
                                                }
                                                @case (REPLICATION_NUMBER === column.id) {
                                                    @if (entry.replicationNumber) {
                                                        {{ entry.replicationNumber }}
                                                    } @else {
                                                        <span>-</span>
                                                    }
                                                }
                                                @case (STATIC_COLUMN_GERMPLASM_DATE === column.id) {
                                                    @if (entry.germplasmDate) {
                                                        {{ entry.germplasmDate }}
                                                    } @else {
                                                        <span>-</span>
                                                    }
                                                }
                                                @default {
                                                }
                                            }
                                        </td>
                                    }
                                </tr>
                            }
                        } @else {
                            <tr>
                                <td [attr.colspan]="displayedColumns.length" class="text-center py-3">
                                    {{ 'study-editor.no-records' | translate }}
                                </td>
                            </tr>
                        }
                    </tbody>
                </table>
            </div>
        </div>
        <div class="d-flex justify-content-between align-items-center mt-3">

            <div>
				@if (numberOfEntries !== numberOfFilteredEntries) {
					<span name="pageDescription" class="text-muted" jhiTranslate="study-editor.pagination.entry-count"
						  [translateValues]="{param1: (currentPage - 1) * pageSize + 1, param2: Math.min(currentPage * pageSize, numberOfFilteredEntries), param3: numberOfFilteredEntries}"></span>
					<span class="text-muted" jhiTranslate="study-editor.pagination.entry-total-count" [translateValues]="{param: numberOfEntries}"></span>
				} @else {
					<span name="pageDescription" class="text-muted" jhiTranslate="study-editor.pagination.entry-count"
						  [translateValues]="{param1: (currentPage - 1) * pageSize + 1, param2: Math.min(currentPage * pageSize, numberOfFilteredEntries), param3: numberOfEntries}"></span>
				}
            </div>

            <div>
                <div class="d-inline-block ms-3">
                    <ngb-pagination
                            [collectionSize]="numberOfFilteredEntries || numberOfEntries"
                            [(page)]="currentPage"
                            [pageSize]="pageSize"
                            [maxSize]="10"
                            [ellipses]="true"
                            [boundaryLinks]="true"
                            [rotate]="true"
                            (pageChange)="onPageChange($event)">
                    </ngb-pagination>
                </div>
                <div class="d-inline-block ms-3">
                    <label for="goToPage" class="me-2" jhiTranslate="study-editor.pagination.go-to">Go to page:</label>
                    <input id="goToPage" type="number" class="form-control d-inline-block w-auto"
                           [min]="1" [max]="Math.ceil((numberOfFilteredEntries || numberOfEntries) / pageSize)"
                           [(ngModel)]="currentPage"
                           (change)="onPageChange(currentPage); $event.preventDefault()"/>
                </div>
            </div>
        </div>
    </div>
</div>



<!-- Column Filter Template -->
<ng-template #columnFilterTemplate>
    <div class="column-filter">
        <!-- Sorting Buttons -->
        <div class="btn-group w-100" role="group" *ngIf="columnDataForFilter.enableFilterSorting !== false">
            <button (click)="sortColumn(columnDataForFilter,true)" class="btn btn-o"
                    [ngClass]="columnDataForFilter.sortingAsc === true ? 'btn-info' : 'btn-outline-secondary'">
                <i class="fa fa-sort-alpha-asc fw-bold fs-6"></i>
            </button>
            <button (click)="sortColumn(columnDataForFilter,false)" class="btn"
                    [ngClass]="columnDataForFilter.sortingAsc === false ? 'btn-info' : 'btn-outline-secondary'">
                <i class="fa fa-sort-alpha-desc fw-bold fs-6"></i>
            </button>
        </div>
        @if (columnDataForFilter.dataTypeCode === 'NUMERIC_LIST') {
            <div class="mt-2">
                <input class="form-control"
                       [(ngModel)]="columnDataForFilter.query"
                       placeholder="{{ 'column-filter.comma.separated.values.placeholder' | translate }}">
            </div>
        }
        @if (columnDataForFilter.dataTypeCode === 'TEXT') {
            <div class="mt-2">
                <input class="form-control"
                       [(ngModel)]="columnDataForFilter.query"
                       placeholder="{{ 'column-filter.contains.text.placeholder' | translate }}">
            </div>
        }
        <!-- Action Buttons -->
        <div class="mt-3">
            <div class="d-flex justify-content-around">
                <div>
                    <button class="btn btn-info ms-2"
                            (click)="filterByColumn(columnDataForFilter)"
                            title="{{ 'global.apply.all.filter' | translate }}"
                            [disabled]="!isApplyAllEnabled(columnDataForFilter)" jhiTranslate="apply">
                        Apply
                    </button>
                    <button class="btn btn-secondary ms-2"
                            (click)="resetFilterByColumn(columnDataForFilter)"
                            title="{{ 'global.reset.filter' | translate }}" jhiTranslate="reset">
                        Reset
                    </button>
                </div>
            </div>
        </div>
    </div>

</ng-template>
